import request from '@/utils/request'

// 获取所有广告类型 分页
export function getAdTypePageAll(data) {
  return request({
    method: 'get',
    url: '/yzdservice/api/ad/type/page/list',
    params: data
  })
}

// 新增/保存 广告类型
export function adTypeAddOrSave(data) {
  return request({
    method: 'post',
    url: '/yzdservice/api/ad/type/addOrSave',
    data: data
  })
}

// 删除 广告类型
export function adTypeDel(adTypeId) {
  return request({
    method: 'delete',
    url: '/yzdservice/api/ad/type/del',
    params: {
      'adTypeId': adTypeId
    }
  })
}

// 获取所有广告数据 分页
export function getAdDataPageAll(page, size, adTypeId) {
  return request({
    method: 'get',
    url: '/yzdservice/api/ad/data/page/list',
    params: {
      page: page,
      size: size,
      adTypeId: adTypeId
    }
  })
}

// 新增/保存 广告数据
export function adDataAddOrSave(data) {
  return request({
    method: 'post',
    url: '/yzdservice/api/ad/data/addOrSave',
    data: data
  })
}

// 删除 广告数据
export function adDataDel(adDataId) {
  return request({
    method: 'delete',
    url: '/yzdservice/api/ad/data/del',
    params: {
      'adDataId': adDataId
    }
  })
}

// 新增/保存 广告内容
export function adContentAddOrSave(adDataId, data) {
  return request({
    method: 'post',
    url: '/yzdservice/api/ad/data/content/addOrSave/' + adDataId,
    data: data
  })
}

// 获取广告内容
export function getAdContent(id) {
  return request({
    method: 'get',
    url: '/yzdservice/api/ad/data/contentById/' + id
  })
}
